import { StepperData } from "../types/common";

export const stepperData: Array<StepperData> = [
  {
    label: "Select Location",
    value: "location",
    stepNumber: 1,
    selected: true,
    completed: false,
    showArrow: true,
  },
  {
    label: "Select exam and date",
    value: "examDetails",
    stepNumber: 2,
    selected: false,
    completed: false,
    showArrow: true,
  },
  {
    label: "Terms and conditions",
    value: "termsAndConditions",
    stepNumber: 3,
    selected: false,
    completed: false,
    showArrow: true,
  },
  {
    label: "Candidate Details",
    value: "candidateData",
    stepNumber: 4,
    selected: false,
    completed: false,
    showArrow: true,
  },
  {
    label: "Confirm and register",
    value: "confirmation",
    stepNumber: 5,
    selected: false,
    completed: false,
    showArrow: false,
  },
  {
    label: "Payment Redirect",
    value: "paymentRedirect",
    stepNumber: 5,
    selected: false,
    completed: false,
    showArrow: false,
  },
  {
    label: "Applied Successfull",
    value: "appliedSuccessful",
    stepNumber: 5,
    selected: false,
    completed: false,
    showArrow: false,
  },
];

export const languageApiData: any = {
  alias: null,
  aliasId: null,
  country: null,
  aboutUrl: null,
  languageCode: null,
  scriptDirection: null,
  venueExamGuid: null,
  trackingId: null,
  pageName: null,
  landingArea: 2,
  siteMetadata: null,
  languages: null,
  redirectUrl: null,
  containerId: null,
};

export const candidateInitialValues = {
  firstName: "",
  lastName: "",
  dob: "",
  gender: "",
  address: "",
  addressLine2: "",
  postCode: "",
  city: "",
  phoneNo: "",
  email: "",
  examReason: "",
  specialRequestType: false,
  specialRequestMessage: "",
  guardianfirstName: "",
  guardianlastName: "",
  guardianmobilenumber: "",
  guardianphonenumber: "",
  guardianConfirmEmail: "",
  guardianEmail: "",
  enableThirdParty: "",
  isThirdPartyCompany: "",
  fiscalNumber: "",
  thirdPartyAddress: "",
  payeeName: "",
  thirdPartyPostCode: "",
  thirdPartyCity: "",
  thirdPartyCountry: "",
  passportEx: {
    day: "",
    month: "",
    year: "",
  },
  country: "",
  nationality: "",
  day: "",
  month: "",
  year: "",
  date: "",
  invoiceType: "myself",
  MarketingConsent: "",
  telephoneNo: "",
  confirmEmail: "",
  VoiceConsent: false,
  UkbaConsent: false,
  PassportNo: "",
  PassportExpiry: "",
  another: {
    taxNumber: "",
    givenName: "",
    surname: "",
    phoneNo: "",
    email: "",
    country: "",
    address: "",
    addressLine2: "",
    postCode: "",
    city: "",
  },
  myself: {
    taxNumber: "",
  },
  company: {
    taxNumber: "",
    companyName: "",
    phoneNo: "",
    email: "",
    country: "",
    address: "",
    addressLine2: "",
    postCode: "",
    city: "",
  },
};

export const invoiceTypeArray: any = {
  myself: "1",
  another: "2",
  company: "3",
};

export const monthNames = [
  { label: "January", value: "01" },
  { label: "February", value: "02" },
  { label: "March", value: "03" },
  { label: "April", value: "04" },
  { label: "May", value: "05" },
  { label: "June", value: "06" },
  { label: "July", value: "07" },
  { label: "August", value: "08" },
  { label: "September", value: "09" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

export const PaymentFailureCode = {
  "10": " Payment was manually cancelled by the user",
  "20": "Payment has been timed out",
  "30": "Payment failed due to transaction failure",
  "40": "Payment has incorrect configuration",
  "50": "Asynchronous payment was cancelled by client app while awaiting for funding",
};

export const PaymentStatus: any = {
  "0": "Payment is registered in NPP, but PSP is not chosen. User is on Decision Page",
  "10": "Payment is ready and PSP is chosen. Awaiting start in PSP system",
  "20": "Payment started in PSP system. Awaiting user action and payment",
  "25": "Asynchronous payment waits for confirmation from PSP. Status applied only for asynchronous payment",
  "28": "Payment partially funded. Status applied only for asynchronous payment",
  "30": "Payment successful. Online application received for",
  "40": "Payment failed. This includes that user cancelled payment or did not pay within timeout period",
  "60": "Payment has been refunded to user. No money is on BC side",
  "80": "NPP could not start payment",
  "90": "Payment has been partially refunded to user",
};
